<template>
    <div class="p-2 bg-white rounded-top">
        <div
            v-if="!standardMap"
            class="d-flex align-items-center text-secondary"
        >
            <div
                class="mr-2 d-flex align-items-center justify-content-center bg-light border border-light rounded"
                style="height: 50px; width: 50px;"
            >
                <font-awesome-icon
                    icon="fa-duotone fa-user-slash"
                    size="lg"
                />
            </div>
            <div>
                <h6 class="mb-0 text-secondary">
                    {{ $t("Unavailable user") }}
                </h6>
                <div class="small">
                    {{ $t("This account is no longer available") }}
                </div>
            </div>
        </div>
        <div v-else class="d-flex align-items-center justify-content-between">
            <div class="text-truncate mr-3">
                <div
                    class="d-flex align-items-center fake-link"
                    @click="viewProfile"
                >
                    <div class="position-relative mr-2">
                        <img
                            height="50"
                            width="50"
                            class="border border-light rounded flag"
                            :src="standardMap.primaryPhoto.small"
                        />
                        <div class="position-absolute online-status-wrapper">
                            <user-online-status
                                size="small"
                                :standardMap="standardMap"
                            />
                        </div>
                    </div>
                    <div class="">
                        <h6 class="text-dark mb-0">
                            <user-primary-badge
                                class="mr-1"
                                :standardMap="standardMap"
                            />
                            {{ standardMap.name }}
                        </h6>
                        <div
                            class="small text-secondary d-flex align-items-center"
                        >
                            <div v-if="brand.creatorLocationPrivacy">
                                {{ standardMap.continentName }}
                            </div>
                            <div v-else class="d-flex align-items-center">
                                <img :src="standardMap.flagUrl" class="mr-1" />
                                {{ standardMap.country }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <user-interest v-if="!disableInterest" :standardMap="standardMap" />
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import UserInterest from "@/components/userHeader/UserInterest";
import UserOnlineStatus from "@/components/user/UserOnlineStatus";
import UserPrimaryBadge from "@/components/user/UserPrimaryBadge";

export default {
    computed: {
        ...mapState("brand", ["brand"]),
    },
    methods: {
        viewProfile() {
            if (this.disableViewProfile) {
                return;
            }

            this.$store.dispatch("profile/viewProfile", {
                userId: this.standardMap.id,
                profile: this.standardMap,
            });
        },
    },
    components: {
        UserInterest,
        UserOnlineStatus,
        UserPrimaryBadge,
    },
    props: ["standardMap", "disableInterest"],
};
</script>